import React from "react";

export default function Test() {
  return (
    <main id="content" className="content">
      <section
        className="vc_row d-flex flex-wrap align-items-center justify-content-center bg-cover pt-150 pb-150"
        style={{ backgroundImage: "url(assets/demo/bg/bg-14.jpg)" }}
      >
        <div className="container">
          <div className="row">
            {/* Left side: Login form */}
            <div className="lqd-column col-md-6">
              <h2 className="text-white mb-30 text-center"></h2>
              
            </div>

            {/* Right side: Image */}
            <div className="lqd-column col-md-6 d-none d-md-block">
              <img
                src="assets/img/CollectKart/google_play.png"
                alt="Login Visual"
                style={{ width: "100%", borderRadius: "8px" }}
              />
            </div>
          </div>
        </div>
      </section>
      {/*  */}

      <section className="vc_row bg-no-repeat pt-100 pb-100" style={{ backgroundImage: "url(assets/demo/bg/bg-76.svg)", backgroundPosition: "-90% 80%" }}>
  <div className="container">
    
    {/* First Div - Left Content, Right Image */}
    <div className="row align-items-center mb-50">
      <div className="col-md-6">
        <div className="content">
          <h2>Title for First Section</h2>
          <p>
          A Phygital platform designed for collection of documents and customer data. A multi-tenant architecture offer flexibility of endless expansion without any hassle. Helping BFSI companies in expanding pan-India operation on our Fintech correspondents/Agency Network. 
          </p>
        </div>
      </div>
      <div className="col-md-6">
        <div className="image">
          <img src="assets/img/CollectKart/ABC.jpg" alt="Image 1" className="img-fluid" />
        </div>
      </div>
    </div>

    {/* Second Div - Right Content, Left Image */}
    <div className="row align-items-center mb-50 flex-row-reverse">
    <div className="col-md-6">
        <div className="image">
          <img src="assets/img/CollectKart/ABC.jpg" alt="Image 2" className="img-fluid" />
        </div>
      </div>
      <div className="col-md-6">
        <div className="content">
          <h2>Document Collection Services</h2>
          <p>
          DocBoyz provides best experience with speed in document collection for Banks & NBFCs. Our pan-India Fintech correspondent network is well trained to handle any financial document collection with full integrity and safety. They are courteous and equipped with our powerful DocBoyz collection app. All the documents are scanned and transmitted digitally in real time using our platform.           </p>
        </div>
      </div>
      
    </div>

    {/* Third Div - Left Content, Right Image */}
    <div className="row align-items-center mb-50">
      <div className="col-md-6">
        <div className="content">
          <h2>Services</h2>
          <ul>
            {/* <li></li> */}
<li>✓ Home Loans Documents</li>
<li>✓ Personal Loans Documents</li>
<li>✓ Auto Loan Documents</li>
<li>✓ Insurance Documents</li>
<li>✓ Payment Mandate and Contact Document  </li>         </ul>
        </div>
      </div>


      <div className="col-md-6">
        <div className="image">
          <img src="assets/img/CollectKart//ABC.jpg" alt="Image 3" className="img-fluid" />
        </div>
      </div>
    </div>
    
  </div>
</section>
{/*  */}
<section className="vc_row bg-no-repeat pt-100 pb-100" style={{ backgroundImage: "url(assets/demo/bg/bg-76.svg)", backgroundPosition: "-90% 80%" }}>
  <div className="container">
    
  </div>
</section>
{/*  */}
<section className="vc_row bg-no-repeat pt-100 pb-100" style={{ backgroundImage: "url(assets/demo/bg/bg-76.svg)", backgroundPosition: "-90% 80%" }}>
  <div className="container">
    
    {/* First Section - Left Content, Right Image */}
    <div className="row align-items-center mb-50">
      <div className="col-md-6">
        <div className="content">
          <h2>Docboyz is now Present in your City</h2>
          <p>
            We are Present Pan-India. We are supported by a digitally enabled pan-India network of Fintech correspondents and the top debt collection agency in India.
          </p>
          <ul className="list-inline">
            <li>24+ States and Union Territories</li>
            <li>580+ Locations</li>
            <li>10,000+ Fintech Correspondents</li>
          </ul>
        </div>
      </div>
      <div className="col-md-6">
        <div className="image">
          <img src="assets/img/india-map.jpg" alt="India Map" className="img-fluid" />
        </div>
      </div>
    </div>

    {/* Second Section - Icons with Information */}
    <div className="row text-center">
      <div className="col-md-2">
        <img src="assets/icons/speed-icon.png" alt="Speed" className="img-fluid mb-2" />
        <p>Speed</p>
      </div>
      <div className="col-md-2">
        <img src="assets/icons/accuracy-icon.png" alt="Accuracy" className="img-fluid mb-2" />
        <p>100% Accuracy</p>
      </div>
      <div className="col-md-2">
        <img src="assets/icons/realtime-icon.png" alt="Real Time" className="img-fluid mb-2" />
        <p>Real Time Update</p>
      </div>
      <div className="col-md-2">
        <img src="assets/icons/data-security-icon.png" alt="Data Security" className="img-fluid mb-2" />
        <p>Data Security</p>
      </div>
      <div className="col-md-2">
        <img src="assets/icons/integration-icon.png" alt="Seamless Integration" className="img-fluid mb-2" />
        <p>Seamless Integration</p>
      </div>
    </div>

  </div>
</section>

{/*  */}

<section className="vc_row bg-no-repeat pt-100 pb-100" style={{ backgroundImage: "url(assets/demo/bg/bg-76.svg)", backgroundPosition: "-90% 80%" }}>
  <div className="container">
    <div className="row">
      
      {/* Left Side: Content (60%) */}
      <div className="lqd-column col-md-7 d-flex flex-column justify-content-center">
        <h2>Collect Kart Debt Collection Platform</h2>
        <p>
          A well-trained team is involved to seamlessly manage other payment collection processes. It provides all the assistance and gets 360-degree support for recovery.
        </p>
        <ul>
          <li>Customization based on the client’s process</li>
          <li>Geolocation-based Agent & Task Monitoring</li>
          <li>Predictive Calling</li>
          <li>Historical Data Analysis</li>
          <li>Dashboards & MIS Reports</li>
          <li>API integration with Financial Systems such as LMS/CRM</li>
          <li>Automated ECG Analysis</li>
          <li>Automated alerts & notifications to the agency representatives</li>
          <li>Automated Triggering</li>
        </ul>
      </div>

      {/* Right Side: Image (40%) */}
      <div className="lqd-column col-md-5 d-flex justify-content-center">
        <img src="assets/demo/collect-kart-software-features.png" alt="Collect Kart Software Features" className="img-fluid" style={{ borderRadius: '8px', maxHeight: '400px' }} />
      </div>
    </div>
  </div>
</section>



    </main>
  );
}
